import React, { ReactNode } from 'react';
import { useTheme } from '@support/hooks/use-theme';

const SettingsIcon = ({ children, viewBox }: { children: ReactNode; viewBox?: string }) => {
  const [theme] = useTheme();

  let color1 = '#EDEFF9';
  let color2 = '#C5C6C7';

  if (theme === 'light') {
    color1 = 'rgba(72, 73, 74, 0.8)';
    color2 = '#48494A';
  }

  return (
    <svg width="12" height="12" viewBox={viewBox || '0 0 12 12'}>
      <defs>
        <linearGradient
          id="settingsIconLG"
          x1="0.5"
          y1="0"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop stopColor={color1} />
          <stop offset="1" stopColor={color2} />
        </linearGradient>
        <linearGradient
          id="settingsIconLG2"
          x1="0.5"
          y1="0"
          x2="0.5"
          y2="1"
          // gradientUnits="objectBoundingBox"
        >
          <stop stopColor={color1} />
          <stop offset="1" stopColor={color2} />
        </linearGradient>
      </defs>
      <g fill="url(#settingsIconLG)" stroke="none">
        {children}
      </g>
    </svg>
  );
};

const iconForSection = {
  'general': () => (
    <SettingsIcon>
      <path d="M6 0C6.6 0 7.1 0.5 7.1 1.1V1.1C7.1 1.5 7.3 1.8 7.6 2C8 2.1 8.4 2 8.6 1.8L8.7 1.8C8.9 1.5 9.1 1.4 9.4 1.4C9.7 1.4 10 1.5 10.2 1.8C10.4 2 10.5 2.2 10.5 2.5C10.5 2.8 10.4 3.1 10.2 3.3L10.2 3.3C9.9 3.6 9.8 4 10 4.3V4.4C10.1 4.7 10.5 4.9 10.8 4.9H10.9C11.5 4.9 12 5.4 12 6C12 6.6 11.5 7.1 10.9 7.1H10.9C10.5 7.1 10.2 7.3 10 7.6C9.9 8 10 8.4 10.2 8.6L10.2 8.7C10.5 8.9 10.6 9.1 10.6 9.4C10.6 9.7 10.5 10 10.2 10.2C10 10.4 9.8 10.5 9.5 10.5C9.2 10.5 8.9 10.4 8.7 10.2L8.7 10.2C8.4 9.9 8 9.8 7.7 10C7.4 10.1 7.1 10.5 7.1 10.8V10.9C7.1 11.5 6.6 12 6 12C5.4 12 5 11.5 5 10.9V10.9C4.9 10.5 4.7 10.2 4.4 10C4 9.9 3.6 10 3.4 10.2L3.3 10.2C3.1 10.5 2.9 10.6 2.6 10.6C2.3 10.6 2 10.5 1.8 10.2C1.6 10 1.5 9.8 1.5 9.5C1.5 9.2 1.6 8.9 1.8 8.7L1.8 8.7C2.1 8.4 2.2 8 2 7.7C1.9 7.4 1.5 7.1 1.2 7.1H1.1C0.5 7.1 0 6.6 0 6C0 5.4 0.5 5 1.1 5H1.1C1.5 4.9 1.8 4.7 2 4.4C2.1 4 2 3.6 1.8 3.4L1.8 3.3C1.5 3.1 1.4 2.9 1.4 2.6C1.4 2.3 1.5 2 1.8 1.8C2 1.6 2.2 1.5 2.5 1.5C2.8 1.5 3.1 1.6 3.3 1.8L3.3 1.8C3.6 2.1 4 2.2 4.3 2H4.4C4.7 1.9 4.9 1.5 4.9 1.2V1.1C4.9 0.5 5.4 0 6 0ZM6 3C4.3 3 3 4.3 3 6C3 7.7 4.3 9 6 9C7.7 9 9 7.7 9 6C9 4.3 7.7 3 6 3ZM6 4.7C6.7 4.7 7.3 5.3 7.3 6C7.3 6.7 6.7 7.3 6 7.3C5.3 7.3 4.7 6.7 4.7 6C4.7 5.3 5.3 4.7 6 4.7Z" />
    </SettingsIcon>
  ),
  'profile': () => (
    <SettingsIcon viewBox="2.5 2.5 13 13">
      <path d="M9 9.33c2.36 0 5.67 3.53 5.67 4.91 0 1.12-2.2 1.43-5.67 1.43-3.47 0-5.67-.31-5.67-1.43 0-1.38 3.3-4.9 5.67-4.9Zm0 1.34c-1.41 0-3.69 2.25-4.22 3.24l-.03.05.11.03.61.12.18.03c.9.12 2.12.2 3.35.2s2.45-.08 3.35-.2l.79-.15.1-.03-.02-.05c-.51-.96-2.65-3.09-4.07-3.24H9ZM9 2.4a3.1 3.1 0 1 1 0 6.2 3.1 3.1 0 0 1 0-6.2Zm0 1.2a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8Z" />
    </SettingsIcon>
  ),
  'integrations': () => (
    <SettingsIcon>
      <path d="M0 6.03C0 6.95 0.15 7.78 0.46 8.52C0.76 9.26 1.19 9.89 1.74 10.4C2.29 10.92 2.94 11.32 3.69 11.59C4.44 11.86 5.26 12 6.15 12C6.63 12 7.07 11.97 7.49 11.92C7.91 11.86 8.25 11.79 8.52 11.7C8.72 11.64 8.85 11.56 8.93 11.47C9.01 11.37 9.04 11.27 9.04 11.16C9.04 11.05 9 10.95 8.93 10.88C8.85 10.8 8.75 10.76 8.63 10.76C8.6 10.76 8.55 10.76 8.5 10.77C8.46 10.78 8.4 10.79 8.34 10.8C8.01 10.87 7.69 10.94 7.38 10.99C7.07 11.04 6.73 11.06 6.34 11.06C5.55 11.06 4.83 10.95 4.19 10.72C3.54 10.5 2.98 10.17 2.52 9.74C2.05 9.31 1.69 8.79 1.43 8.17C1.18 7.55 1.06 6.85 1.06 6.06C1.06 5.3 1.18 4.61 1.42 3.99C1.66 3.36 2 2.82 2.45 2.36C2.89 1.9 3.42 1.55 4.04 1.3C4.66 1.05 5.35 0.93 6.11 0.93C6.78 0.93 7.42 1.03 8.01 1.23C8.6 1.43 9.12 1.72 9.57 2.11C10.03 2.49 10.38 2.97 10.64 3.53C10.89 4.09 11.02 4.73 11.02 5.46C11.02 6.29 10.89 6.95 10.62 7.46C10.35 7.97 9.99 8.22 9.53 8.22C9.23 8.22 8.99 8.14 8.83 7.97C8.66 7.8 8.58 7.57 8.58 7.27V3.55C8.58 3.2 8.41 3.02 8.07 3.02C7.91 3.02 7.78 3.06 7.69 3.16C7.6 3.26 7.55 3.39 7.55 3.55V4.14H7.49C7.34 3.8 7.1 3.52 6.77 3.32C6.44 3.12 6.06 3.02 5.64 3.02C5.14 3.02 4.7 3.14 4.32 3.4C3.94 3.66 3.64 4.01 3.43 4.47C3.21 4.92 3.1 5.45 3.1 6.04C3.1 6.65 3.21 7.17 3.43 7.63C3.64 8.09 3.95 8.45 4.33 8.71C4.71 8.97 5.16 9.1 5.67 9.1C6.11 9.1 6.5 8.99 6.83 8.77C7.15 8.55 7.4 8.24 7.57 7.84H7.62C7.69 8.24 7.88 8.54 8.19 8.77C8.51 8.99 8.89 9.1 9.35 9.1C9.9 9.1 10.37 8.95 10.77 8.63C11.16 8.31 11.47 7.88 11.68 7.32C11.89 6.76 12 6.12 12 5.4C12 4.58 11.86 3.84 11.57 3.18C11.28 2.52 10.87 1.95 10.34 1.47C9.82 1 9.2 0.63 8.48 0.38C7.76 0.13 6.97 0 6.12 0C5.22 0 4.4 0.14 3.65 0.43C2.9 0.71 2.26 1.12 1.71 1.65C1.17 2.18 0.74 2.82 0.45 3.56C0.15 4.29 0 5.12 0 6.03ZM5.86 8.14C5.53 8.14 5.25 8.06 5 7.88C4.76 7.71 4.57 7.47 4.44 7.16C4.31 6.84 4.24 6.47 4.24 6.05C4.24 5.62 4.31 5.25 4.44 4.94C4.57 4.63 4.76 4.39 5.01 4.22C5.25 4.05 5.54 3.96 5.87 3.96C6.38 3.96 6.78 4.15 7.08 4.52C7.37 4.89 7.52 5.39 7.52 6.02C7.52 6.45 7.46 6.82 7.32 7.14C7.18 7.46 6.99 7.7 6.74 7.88C6.49 8.05 6.2 8.14 5.86 8.14Z" />
    </SettingsIcon>
  ),
  'notifications': () => (
    <SettingsIcon viewBox="-1 0 12 12">
      <circle cx="9" cy="2" r="2" />
      <path d="M2.4 2.2C1.7 2.2 1.2 2.7 1.2 3.4V8.6C1.2 9.3 1.7 9.8 2.4 9.8H7.6C8.3 9.8 8.8 9.3 8.8 8.6V6C8.8 5.7 9 5.4 9.4 5.4C9.7 5.4 10 5.7 10 6V8.6C10 9.9 8.9 11 7.6 11H2.4C1.1 11 0 9.9 0 8.6V3.4C0 2.1 1.1 1 2.4 1H5C5.3 1 5.6 1.3 5.6 1.6C5.6 2 5.3 2.2 5 2.2H2.4Z" />
    </SettingsIcon>
  ),
  'home': () => (
    <SettingsIcon viewBox="0 0 18 20">
      <g strokeWidth="2">
        <path
          fill="none"
          d="M1.4 7L9 1L16.6 7C16.8 7.2 17 7.5 17 7.8V17.2C17 18.2 16.2 19 15.2 19H2.8C1.8 19 1 18.2 1 17.2V7.8C1 7.5 1.2 7.2 1.4 7Z"
          strokeLinejoin="round"
          stroke="url(#settingsIconLG)"
        />
        <rect x="5" y="13" width="2" height="2" rx="0.1" stroke="url(#settingsIconLG)" />
      </g>
    </SettingsIcon>
  ),
  'appearance': () => (
    <SettingsIcon>
      <path d="M6 10.4C8.4 10.4 10.4 8.4 10.4 6C10.4 3.6 8.4 1.6 6 1.6V10.4ZM11.5 6C11.5 9 9 11.5 6 11.5C5.8 11.5 5.6 11.5 5.4 11.5C2.6 11.2 0.5 8.8 0.5 6C0.5 3.2 2.6 0.8 5.4 0.5C5.6 0.5 5.8 0.5 6 0.5C9 0.5 11.5 3 11.5 6Z" />
    </SettingsIcon>
  ),
  'about': () => (
    <SettingsIcon>
      <path d="M6 1.6C3.6 1.6 1.6 3.6 1.6 6C1.6 8.4 3.6 10.4 6 10.4C8.4 10.4 10.4 8.4 10.4 6C10.4 3.6 8.4 1.6 6 1.6ZM0.5 6C0.5 3 3 0.5 6 0.5C9 0.5 11.5 3 11.5 6C11.5 9 9 11.5 6 11.5C3 11.5 0.5 9 0.5 6Z M6 5.2C6.3 5.2 6.6 5.4 6.6 5.8V8.3C6.6 8.6 6.3 8.9 6 8.9C5.7 8.9 5.4 8.6 5.4 8.3V5.8C5.4 5.4 5.7 5.2 6 5.2Z" />
      <rect x="5.4" y="5.2" width="1.2" height="3.7" rx="0.6" />
      <circle cx="6" cy="3.73" r="0.73" />
    </SettingsIcon>
  ),
  'staging': () => (
    <SettingsIcon>
      <circle stroke="url(#settingsIconLG)" fill="none" cx="6" cy="6" r="5.5" />
      <circle cx="4" cy="4.5" r="1" stroke="none" />
      <circle cx="8" cy="4.5" r="1" stroke="none" />
      <path
        stroke="url(#settingsIconLG)"
        fill="none"
        d="M3 7a3.25 3.25 0 0 0 6 0"
        strokeLinecap="round"
      />
    </SettingsIcon>
  ),
  'workspace-general': () => (
    <SettingsIcon>
      <path d="M9 6.6C9.9 6.8 10.5 7.6 10.5 8.5C10.5 9.6 9.6 10.5 8.5 10.5C7.4 10.5 6.5 9.6 6.5 8.5C6.5 7.6 7.1 6.8 8 6.6V2C8 1.7 8.2 1.5 8.5 1.5C8.8 1.5 9 1.7 9 2V6.6Z" />
      <path d="M3.5 10.5C3.2 10.5 3 10.3 3 10V6.4C2.1 6.2 1.5 5.4 1.5 4.5C1.5 3.6 2.1 2.8 3 2.6V2C3 1.7 3.2 1.5 3.5 1.5C3.8 1.5 4 1.7 4 2V2.6C4.9 2.8 5.5 3.6 5.5 4.5C5.5 5.4 4.9 6.2 4 6.4V10C4 10.3 3.8 10.5 3.5 10.5Z" />
    </SettingsIcon>
  ),
  'workspace-members': () => (
    <SettingsIcon>
      <path
        d="M3.9 6C3.3 6.3 2.8 6.7 2.4 7.2C2 7.6 1.7 8.2 1.5 8.8"
        stroke="url(#settingsIconLG)"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M3.7 4.2C3 4 2.7 3.3 2.9 2.6C3.1 2 3.8 1.6 4.5 1.8"
        stroke="url(#settingsIconLG)"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M7.3 7.3C5.6 7.3 4 9.5 4 9.8C4 10.1 5.6 10.3 7.3 10.3C8.9 10.3 10.5 10.1 10.5 9.8C10.5 9.5 8.9 7.3 7.3 7.3Z"
        stroke="url(#settingsIconLG)"
      />
      <circle cx="7.25" cy="4" r="2" />
    </SettingsIcon>
  ),
};

export default iconForSection;
